import PropTypes from 'prop-types';
import React from 'react';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';

import EyeClosedIcon from '../../../../assets/img/EyeClosedIcon';
import EyeDollarIcon from '../../../../assets/img/EyeDollarIcon';
import { USERS_ACTIONS } from '../../../store/actions/reducer-actions/users';
import { Colors } from '../../../styles/vars';
import { connect } from '../../../utils/redux';
import Paths from '../../routes/paths';
import Button from '../Button';

const PriceModeSwitcher = ({ isPriceHidden, setUserPriceHidden }) => {
  if (isPriceHidden) {
    return (
      <Button
        fromComponent={NavLink}
        to={Paths.Login()}
        color={Colors.black}
        background={Colors.pureWhite}
        hoverColor={Colors.black}
        hoverBackground={Colors.white}
      >
        <EyeClosedIcon />
        <span>Afficher les prix</span>
      </Button>
    );
  }

  return (
    <Button
      type="button"
      color={Colors.black}
      background={Colors.pureWhite}
      hoverColor={Colors.black}
      hoverBackground={Colors.white}
      onClick={() => setUserPriceHidden(!isPriceHidden)}
    >
      <EyeDollarIcon />
      <span>Masquer les prix</span>
    </Button>
  );
};

PriceModeSwitcher.propTypes = {
  isPriceHidden: PropTypes.bool,
  setUserPriceHidden: PropTypes.func.isRequired,
};

PriceModeSwitcher.defaultProps = {
  isPriceHidden: false,
};

export default connect(
  state => ({ isPriceHidden: state.users?.currentUser?.isPriceHidden }),
  { setUserPriceHidden: USERS_ACTIONS.setUserPriceHidden },
)(PriceModeSwitcher);
